// extracted by mini-css-extract-plugin
export var alignLeft = "t_p5 d_fl d_bC d_dr";
export var alignCenter = "t_bL d_fm d_bz d_ds";
export var alignRight = "t_p6 d_fn d_bD d_dt";
export var comparisonComponent = "t_h0 d_h0 d_bh";
export var comparisonComponentHighlighted = "t_hY d_hY d_bj d_cz d_s";
export var comparisonComponentContent = "t_jj d_jj d_h6 d_bZ d_b2";
export var comparisonComponentContentLeft = "t_jb d_jb d_h6 d_s d_bL";
export var comparisonComponentContentRight = "t_jc d_jc d_h6 d_s d_bL";
export var comparisonComponentContentHighlighted = "t_jf d_jf d_s d_bZ d_b2 d_bL";